import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../UserContext";

const apiBaseURL = process.env.REACT_APP_BACKEND_API_URL;

const CoachConfig = () => {
  const [configurations, setConfigurations] = useState([]);  // eslint-disable-line no-unused-vars
  const [editableConfigurations, setEditableConfigurations] = useState([]);
  const [isEditable, setIsEditable] = useState(false);
  const { user } = useContext(UserContext);

  useEffect(() => {
    const fetchCoachConfig = async () => {
      try {
        const response = await fetch(
          `${apiBaseURL}/configurations/${user.user_id}?configuration_type=Intention Adjustment`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          setConfigurations(data);
          setEditableConfigurations(data.map((config) => ({ ...config }))); // Create a copy for editing
        } else {
          console.error("Failed to fetch session configurations.");
        }
      } catch (error) {
        console.error("Error fetching session configurations:", error);
      }
    };

    fetchCoachConfig();
  }, [user.user_id]);

  const handleInputChange = (index, value) => {
    const updatedConfigurations = [...editableConfigurations];
    updatedConfigurations[index].configuration_value = value; // Allow any input
    setEditableConfigurations(updatedConfigurations);
  };

  const handleSave = async () => {
    try {
      for (let config of editableConfigurations) {
        const response = await fetch(
          `${apiBaseURL}/configurations/${user.user_id}/${config.configuration_name}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              configuration_value: config.configuration_value,
            }),
          }
        );

        if (!response.ok) {
          console.error(`Failed to update ${config.configuration_name}`);
        }
      }

      setConfigurations([...editableConfigurations]); // Update the original configurations
      setIsEditable(false);
    } catch (error) {
      console.error("Error updating configurations:", error);
    }
  };

  // const handleCancel = () => {
  //   // Revert to original values
  //   fetchCoachConfig();
  //   setEditableConfigurations([...configurations]);
  //   setIsEditable(false);
  // };

   const handleCancel = () => {
    // Revert to original values by re-fetching from server
    const fetchCoachConfig = async () => {
      try {
        const response = await fetch(
          `${apiBaseURL}/configurations/${user.user_id}?configuration_type=Intention Adjustment`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          setConfigurations(data);
          setEditableConfigurations(data.map((config) => ({ ...config }))); // Create a copy for editing
        } else {
          console.error("Failed to fetch session configurations.");
        }
      } catch (error) {
        console.error("Error fetching session configurations:", error);
      }
    };
    
    fetchCoachConfig();
    setIsEditable(false);
  };

  const toggleEdit = () => {
    setIsEditable(!isEditable);
  };

  return (
    <div className="bg-white max-w-7xl mx-auto text-gray-800 mt-4">
      <div className="space-y-5">
        {editableConfigurations.map((config, index) => (
          <div key={config.configuration_name} className="flex flex-col">
            <label className="text-gray-700 font-medium mb-1">
              {config.configuration_name}:
            </label>
            <input
              type="text"
              value={config.configuration_value}
              onChange={(e) => handleInputChange(index, e.target.value)}
              className="px-3 py-2 w-full bg-gray-100 focus:outline-none focus:ring-2 focus:ring-teal-400 transition-all rounded-md"
              disabled={!isEditable}
            />
          </div>
        ))}
      </div>

      <div className="flex justify-end space-x-3 mt-6">
        {!isEditable ? (
          <button
            onClick={toggleEdit}
            className="bg-teal-400 text-white px-5 py-2 rounded-md hover:bg-teal-500 transition-all"
          >
            Edit
          </button>
        ) : (
          <>
            <button
              onClick={handleSave}
              className="bg-teal-400 text-white px-5 py-2 rounded-md hover:bg-teal-500 transition-all"
            >
              Save
            </button>
            <button
              onClick={handleCancel}
              className="bg-gray-300 text-gray-700 px-5 py-2 rounded-md hover:bg-gray-400 transition-all"
            >
              Cancel
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default CoachConfig;
